import compose from 'recompose/compose';
import Base from "./Base";
import Circle from "./Circle";
import frame1 from "./frame1";
import frame2 from "./frame2";
import frame3 from "./frame3";
import frame4 from "./frame4";
import frame5 from "./frame5";
import frame6 from "./frame6";
import frame7 from "./frame7";
import frame8 from "./frame8";
import frame9 from "./frame9";
import frame10 from "./frame10";
import frame11 from "./frame11";
import frame12 from "./frame12";
import frame13 from "./frame13";
import frame14 from "./frame14";
import frame15 from "./frame15";
import frame16 from "./frame16";
import frame17 from "./frame17";
import frame18 from "./frame18";
import frame19 from "./frame19";
import frame20 from "./frame20";
import frame21 from "./frame21";
import frame22 from "./frame22";
import frame23 from "./frame23";
import frame24 from "./frame24";

import optionCallback from "./optionCallback";

const options = {
	toPath: {
		type: 'element',
		name: 'rect',
		attributes: { width: 1000, height: 200 }
	}
}

export default compose(
	optionCallback('frame0', Base),
	optionCallback('frame1', frame1, options),
	optionCallback('frame2', frame2, options),
	optionCallback('frame3', frame3, options),
	optionCallback('frame4', frame4, options),
	optionCallback('frame5', frame5, options),
	optionCallback('frame6', frame6, options),
	optionCallback('frame7', frame7, options),
	optionCallback('frame8', frame8, options),
	optionCallback('frame9', frame9, options),
	optionCallback('frame10', frame10, options),
	optionCallback('frame11', frame11, options),
	optionCallback('frame12', frame12, options),
	optionCallback('frame13', frame13, options),
	optionCallback('frame14', frame14, options),
	optionCallback('frame15', frame15, options),
	optionCallback('frame16', frame16, options),
	optionCallback('frame17', frame17, options),
	optionCallback('frame18', frame18, options),
	optionCallback('frame19', frame19, options),
	optionCallback('frame20', frame20, options),
	optionCallback('frame21', frame21, options),
	optionCallback('frame22', frame22, options),
	optionCallback('frame23', frame23, options),
	optionCallback('frame24', frame24, options),
	optionCallback('circle', Circle),
	
	optionCallback('default', Base) // default phải luôn ở cuối
)